'use client';

import { usePremium } from '@/contexts/PremiumContext';
import { Crown, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';
import { PremiumUpgradeDialog } from './PremiumUpgradeDialog';

export function PremiumBadge() {
  const { isPremium } = usePremium();
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);

  if (isPremium) {
    return (
      <div
        className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-[#0a192f] font-semibold text-sm"
      >
        <Crown className="w-4 h-4" />
        <span>Premium</span>
        <Sparkles className="w-4 h-4" />
      </div>
    );
  }

  return (
    <>
      <Button
        onClick={() => setUpgradeDialogOpen(true)}
        className="bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-[#0a192f] hover:opacity-90 font-semibold"
      >
        <Crown className="w-4 h-4 mr-2" />
        Passer à Premium
      </Button>
      <PremiumUpgradeDialog
        open={upgradeDialogOpen}
        onOpenChange={setUpgradeDialogOpen}
      />
    </>
  );
}
